<template>
    <v-main>
      <CommunicationChatContainer />
    </v-main>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";
import CommunicationChatContainer from '@/container/communication/CommunicationChatContainer.vue';
import { pusherModule } from '@/store/dataModules/pusherModule';

export default defineComponent({
  components: {
    CommunicationChatContainer,
  },
  mounted() {
  },
});
</script>
